import { LoadSpinner } from '@calizahq/react-components-v2'
import { Navigation } from '@shared/Navigation/Navigation'
import { Fragment, PropsWithChildren, useEffect } from 'react'
import { useLocation } from 'react-router-dom'

import { SignInModal } from '@/components'
import { useUserContext } from '@/context'
import { useGeolocation } from '@/hooks/useGeolocation'

export function Layout({ children }: PropsWithChildren<{}>) {
  const { isLoggedIn, isLoading, logoutUser } = useUserContext()
  const { captureGeolocation } = useGeolocation()

  const { pathname } = useLocation()

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [pathname])

  useEffect(() => {
    if (isLoggedIn) {
      // Pre-warm the browser permission prompt on login so field ops see it
      // immediately rather than when they first trigger a mutation.
      void captureGeolocation()
    }
  }, [isLoggedIn, captureGeolocation])

  const onTryAgain = () => {
    logoutUser()
  }

  if (isLoading)
    return (
      <div className="flex h-screen w-screen flex-col items-center justify-center px-4">
        <LoadSpinner className="icon-secondary" isCurrentColor={true} size={2} />
        <p className="mt-8 text-center text-lg" style={{ fontWeight: 700 }}>
          {'Continue in "Sign in with Google" browser window to finish logging in'}
        </p>
        <p className="mt-40 self-stretch text-center">
          If something went wrong <br />
          <span className="cursor-pointer text-green-300 underline" onClick={onTryAgain} role="presentation">
            click here to try to log in again
          </span>
        </p>
      </div>
    )

  function renderLayout() {
    if (!isLoggedIn) return null
    return <Navigation>{children}</Navigation>
  }

  return (
    <Fragment>
      <SignInModal isShown={!isLoggedIn} />
      {renderLayout()}
    </Fragment>
  )
}
